import { reduxKey } from './constants';
import { PapiDeviation } from '@wix/da-papi-types';
import { Location } from 'history';

export type DuperbrowseItemId = number | string;
export type DuperbrowseItem = PapiDeviation;
export type DuperbrowseNormalizedItem = DuperbrowseItem | DuperbrowseItemId;
export type DuperbrowseItemSchema = 'deviation';

export interface DuperbrowseStream {
  itemSchema?: DuperbrowseItemSchema;
  streamId: string;
  // stored separately from "parent" in case there's no parent item
  parent?: {
    title?: string;
    typeId?: number;
    itemId?: number;
  };
  streamItemSelector?: (state: any, streamId: string) => DuperbrowseNormalizedItem[];
  preloadEnabled?: boolean;
}

export interface DuperbrowseSimpleStream extends DuperbrowseStream {
  items: DuperbrowseNormalizedItem[];
}

export function isSimpleStream(stream: DuperbrowseStream): stream is DuperbrowseSimpleStream {
  return stream.hasOwnProperty('items');
}

export interface DuperbrowseLoadableStream extends DuperbrowseStream {
  enableLoader?: boolean;
}

export function isLoadableStream(stream: DuperbrowseStream): stream is DuperbrowseLoadableStream {
  return !stream.hasOwnProperty('items');
}

export interface ActiveDuperbrowseStream extends DuperbrowseStream {
  currentOpenItem: DuperbrowseItemId;
  parent: NonNullable<DuperbrowseStream['parent']> & {
    url: string;
  };
}

export type RootStream = Omit<ActiveDuperbrowseStream, 'parent'>;

export interface DuperbrowseState {
  isSessionActive: boolean;
  isHistoryManagementEnabled: boolean;

  // last viewed item in last closed stream, for scroll restoration
  lastViewedItem?: {
    streamId: string;
    itemId: DuperbrowseItemId;
  };

  streamStack: ActiveDuperbrowseStream[];
  rootStream?: RootStream;
  rootLocation?: Location<any>;
  loadCount?: number;

  // Map of bi metadata per item
  currentBiMetadata?: Record<string, string>;
}

export interface DuperbrowseStoreSlice {
  [reduxKey]?: DuperbrowseState;
}

export interface DuperbrowseHostInitOptions {
  initialStream?: RootStream;
  enableHistoryManagement?: boolean;
}

export interface DuperbrowseNavigationItem {
  nextItem?: DuperbrowseItem;
  prevItem?: DuperbrowseItem;
}

export interface DuperbrowseHistoryState {
  duperbrowseState?: {
    streamId: string;
    itemId: DuperbrowseItemId;
  };
  duperbrowseRoot?: boolean;
}
